export default __webpack_public_path__ + "static/media/chart.bf6def95.PNG";